import { z } from 'zod'
import { ErrorCode } from '~/types/error'

export const loginSchema = z.object({
  email: z.string().min(1, ErrorCode.REQUIRED).email(ErrorCode.INVALID_EMAIL),
  password: z.string().min(1, ErrorCode.REQUIRED),
})

export type LoginFormData = z.infer<typeof loginSchema>
